/**
 * gecx-modal.js
 * Wraps the GECX chat-messenger in a custom modal shell.
 * - Custom backdrop + modal container
 * - Custom title bar (Ask Kiyoko + BETA + refresh + close)
 * - Hides GECX's native title bar via shadow DOM injection
 * - Desktop: centered modal
 * - Mobile: bottom sheet
 */

(function () {
  var modal = null;
  var backdrop = null;
  var isOpen = false;

  function buildModal() {
    if (document.getElementById('kiyoko-chat-modal')) return;

    // ── Backdrop ──
    backdrop = document.createElement('div');
    backdrop.id = 'kiyoko-chat-backdrop';
    backdrop.addEventListener('click', closeModal);
    document.body.appendChild(backdrop);

    // ── Modal shell ──
    modal = document.createElement('div');
    modal.id = 'kiyoko-chat-modal';
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-label', 'Ask Kiyoko');

    // Title bar
    var titleBar = document.createElement('div');
    titleBar.className = 'kiyoko-chat-titlebar';

    var titleLeft = document.createElement('div');
    titleLeft.className = 'kiyoko-chat-titlebar__left';

    var sparkleImg = document.createElement('img');
    sparkleImg.className = 'kiyoko-chat-titlebar__sparkle';
    sparkleImg.alt = '';
    sparkleImg.width = 18;
    sparkleImg.height = 18;
    // URL set after DOM ready via data attribute on button
    var headerBtn = document.querySelector('.header-gecx-btn');
    sparkleImg.src = headerBtn ? headerBtn.dataset.sparkle : '';

    var titleText = document.createElement('span');
    titleText.className = 'kiyoko-chat-titlebar__title';
    titleText.textContent = 'Ask Kiyoko';

    var betaBadge = document.createElement('span');
    betaBadge.className = 'kiyoko-chat-titlebar__beta';
    betaBadge.textContent = 'BETA';

    titleLeft.appendChild(sparkleImg);
    titleLeft.appendChild(titleText);
    titleLeft.appendChild(betaBadge);

    var titleActions = document.createElement('div');
    titleActions.className = 'kiyoko-chat-titlebar__actions';

    // Refresh button
    var refreshBtn = document.createElement('button');
    refreshBtn.className = 'kiyoko-chat-titlebar__btn';
    refreshBtn.setAttribute('aria-label', 'Restart chat');
    refreshBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>';
    refreshBtn.addEventListener('click', function () {
      var widget = document.querySelector('gecx-shopify-chat-widget');
      if (widget && widget.startNewSession) {
        widget.startNewSession();
      }

      // Hide old messages manually since GECX doesn't clear them
      var container = document.querySelector('chat-messenger-container');
      var shadow = container && container.shadowRoot;
      var wrapper = shadow && shadow.querySelector('.message-list-wrapper');
      var msgList = wrapper && wrapper.querySelector('chat-messenger-message-list');
      var content = msgList && msgList.shadowRoot && msgList.shadowRoot.querySelector('.content');
      if (content) {
        // Hide existing entries
        Array.from(content.querySelectorAll('.entry')).forEach(function(e) {
          e.style.setProperty('display', 'none', 'important');
        });
      }

      // Show landing UI
      var entry = document.querySelector('.kiyoko-entry-point');
      if (entry) {
        entry.style.display = '';
        entry.style.opacity = '1';
      }

      // Stop existing poller and restart message watching for new messages
      if (messagePoller) { clearInterval(messagePoller); messagePoller = null; }
      setTimeout(watchForMessages, 800);
    });

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.className = 'kiyoko-chat-titlebar__btn';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    closeBtn.addEventListener('click', closeModal);

    titleActions.appendChild(refreshBtn);
    titleActions.appendChild(closeBtn);

    titleBar.appendChild(titleLeft);
    titleBar.appendChild(titleActions);

    // Chat body — will hold the chat-messenger
    var chatBody = document.createElement('div');
    chatBody.className = 'kiyoko-chat-body';
    chatBody.id = 'kiyoko-chat-body';

    // Terms footer
    var terms = document.createElement('div');
    terms.className = 'kiyoko-chat-terms';
    terms.innerHTML = 'Ask Kiyoko is AI and can make mistakes. By chatting, you agree to our <a href="/policies/privacy-policy">Privacy Policy</a> and <a href="/policies/terms-of-service">Terms of Service</a>.';

    // Mobile drag handle
    var dragHandle = document.createElement('div');
    dragHandle.className = 'kiyoko-chat-drag-handle';

    modal.appendChild(dragHandle);
    modal.appendChild(titleBar);
    modal.appendChild(chatBody);

    document.body.appendChild(modal);

    // Move chat-messenger into our modal body
    moveChatMessenger();

    // Append terms after chat-messenger so it stays on top
    chatBody.appendChild(terms);

    // Inject entry point slot — retry since container may not exist yet
    var epAttempts = 0;
    (function tryInjectEntry() {
      var msg = document.querySelector('chat-messenger');
      var cont = msg && msg.querySelector('chat-messenger-container');
      if (cont && !cont.querySelector('.kiyoko-entry-point')) {
        injectEntryPoint();
      } else if (!cont && epAttempts++ < 40) {
        setTimeout(tryInjectEntry, 100);
      }
    })();

    // Mobile drag-to-dismiss
    initDragToDismiss();
  }

  function injectEntryPoint() {
    var messenger = document.querySelector('chat-messenger');
    if (!messenger) return;
    var container = messenger.querySelector('chat-messenger-container');
    if (!container) return;
    if (container.querySelector('.kiyoko-entry-point')) return;

    var btn = document.querySelector('.header-gecx-btn');
    var entryLogoUrl = btn ? btn.dataset.entryLogo : '';
    var sparkleUrl = btn ? btn.dataset.sparkle : '';

    var entry = document.createElement('div');
    entry.className = 'kiyoko-entry-point';
    entry.setAttribute('slot', 'messages-header');
    entry.innerHTML = [
      '<div class="kiyoko-entry__avatar">',
        '<img src="' + sparkleUrl + '" alt="Kiyoko">',
      '</div>',
      '<div class="kiyoko-entry__heading">',
        '<h2>Hi! I\u2019m Kiyoko \uD83D\uDC4B</h2>',
      '</div>',
      '<p class="kiyoko-entry__subtitle">Your Asian Beauty guide. Tell me about your skin, and I\u2019ll help you find products you\u2019ll love.</p>'
    ].join('');

    container.appendChild(entry);
  }

  var messagePoller = null;

  var _bodyFont = null;
  function getBodyFont() {
    if (_bodyFont) return _bodyFont;
    _bodyFont = window.getComputedStyle(document.documentElement).getPropertyValue('--font-body--family').trim() || 'sans-serif';
    return _bodyFont;
  }

  // Walk all shadow roots under a root node and inject chip/message styles.
  function injectBotMessageStylesDeep(root) {
    injectBotMessageStyles(root);
    root.querySelectorAll('*').forEach(function(el) {
      if (el.shadowRoot) {
        injectBotMessageStyles(el.shadowRoot);
        injectBotMessageStylesDeep(el.shadowRoot);
      }
    });
  }

  function injectBotMessageStyles(root) {
    // Style suggestion chips
    root.querySelectorAll('df-chips').forEach(function(el) {
      if (el.dataset.kiyokoStyled) return;
      if (!el.shadowRoot) return; // shadow root not ready yet — retry later
      el.dataset.kiyokoStyled = 'true';
      var style = document.createElement('style');
      style.textContent = `
        .chip {
          border-radius: 20px !important;
          padding: 0 !important;
        }
        .chip a, .chip button {
          border: 1px solid #E1E1E1 !important;
          border-radius: 20px !important;
          background: #ffffff !important;
          font-family: ` + getBodyFont() + ` !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          padding: 10px !important;
        }
      `;
      el.shadowRoot.appendChild(style);
    });

    root.querySelectorAll('df-markdown-message').forEach(function(el) {
      if (el.dataset.kiyokoStyled) return;
      if (!el.shadowRoot) return;
      el.dataset.kiyokoStyled = 'true';
      var style = document.createElement('style');
      style.textContent = '.message.bot-message p, .message.bot-message li, .message.bot-message ul, .message.bot-message ol { font-family: ' + getBodyFont() + ' !important; font-weight: 500 !important; line-height: 150% !important; font-size: 16px;} .message.bot-message { font-family: ' + getBodyFont() + ' !important; }';
      el.shadowRoot.appendChild(style);
    });
    root.querySelectorAll('chat-messenger-utterance').forEach(function(el) {
      if (!el.shadowRoot || el.dataset.kiyokoStyled) return;
      el.dataset.kiyokoStyled = 'true';
      new MutationObserver(function() {
        injectBotMessageStylesDeep(el.shadowRoot);
      }).observe(el.shadowRoot, { childList: true, subtree: true });
    });
    // User messages live inside df-text-message's shadow root
    root.querySelectorAll('df-text-message').forEach(function(el) {
      if (!el.shadowRoot || el.dataset.kiyokoStyled) return;
      el.dataset.kiyokoStyled = 'true';
      var s = document.createElement('style');
      s.textContent = '.message.user-message { font-family: ' + getBodyFont() + ' !important; font-weight: 500 !important; }';
      el.shadowRoot.appendChild(s);
    });
  }

  // Watch a newly-added .entry.bot.
  // - processCarousel() calls revealEntry() for carousel entries whenever the
  //   carousel scan finds one — this function doesn't need to handle those.
  // - For plain-text / chips entries, reveal after a timeout if processCarousel
  //   hasn't already claimed the entry.
  // We use a generous timeout because GECX can take 1-2s to build carousels
  // inside shadow roots, and we must not reveal a carousel entry early.
  function monitorEntryForReveal(entryEl) {
    if (entryEl._kiyokoMonitored) return; // already being monitored
    entryEl._kiyokoMonitored = true;
    var done = false;
    var pollTimer = null;
    var fallbackTimer = null;

    function finish() {
      if (done) return;
      done = true;
      clearTimeout(pollTimer);
      clearTimeout(fallbackTimer);
      obs.disconnect();
      if (!entryEl.isConnected || !entryEl.dataset.kiyokoHidden) return;
      // Don't reveal if a carousel or single product card is present —
      // their handlers call revealEntry once our custom card is ready.
      var carousels = [];
      collectCarousels(entryEl, carousels);
      if (carousels.length > 0) return;
      if (findInShadowsByTag(entryEl, 'df-product-detail')) return;
      revealEntry(entryEl);
      injectBotMessageStylesDeep(entryEl);
      setTimeout(function() { injectBotMessageStylesDeep(entryEl); }, 200);
      setTimeout(function() { injectBotMessageStylesDeep(entryEl); }, 600);
    }

    // Poll every 100ms for text/chip content appearing in the entry.
    // Reveals as soon as content is detected rather than waiting the full
    // fallback timeout — makes chip responses feel instant.
    function poll() {
      if (done || !entryEl.isConnected) return;
      if (!entryEl.dataset.kiyokoHidden) { done = true; obs.disconnect(); return; }
      // Check for any renderable content in shadow roots
      var hasTextOrChips = !!(findInShadowsByTag(entryEl, 'df-markdown-message') ||
                              findInShadowsByTag(entryEl, 'df-chips'));
      var hasSingleProduct = findInShadowsByTag(entryEl, 'df-product-detail');
      var hasContent = hasTextOrChips || hasSingleProduct;
      if (hasContent) {
        var carousels = [];
        collectCarousels(entryEl, carousels);
        // For single products, handleSingleProduct handles the reveal — just stop polling.
        if (hasSingleProduct && !hasTextOrChips) { done = true; obs.disconnect(); clearTimeout(fallbackTimer); return; }
        if (carousels.length === 0) { finish(); return; }
      }
      pollTimer = setTimeout(poll, 100);
    }

    // Hard fallback — reveal after 1500ms for carousels, 4s for single products
    // (longer because handleSingleProduct needs time to fetch and inject).
    fallbackTimer = setTimeout(function() {
      if (done) return;
      // For product entries, give handleSingleProduct/processCarousel more time
      if (findInShadowsByTag(entryEl, 'df-product-detail') ||
          findInShadowsByTag(entryEl, 'df-product-detail-carousel')) {
        setTimeout(function() {
          if (!done && entryEl.isConnected && entryEl.dataset.kiyokoHidden) {
            done = true;
            obs.disconnect();
            revealEntry(entryEl);
          }
        }, 2500);
      } else {
        finish();
      }
    }, 1500);

    // Also watch for processCarousel clearing kiyokoHidden.
    var obs = new MutationObserver(function() {
      if (!entryEl.dataset.kiyokoHidden) {
        clearTimeout(fallbackTimer);
        clearTimeout(pollTimer);
        done = true;
        obs.disconnect();
        injectBotMessageStylesDeep(entryEl);
        setTimeout(function() { injectBotMessageStylesDeep(entryEl); }, 200);
        setTimeout(function() { injectBotMessageStylesDeep(entryEl); }, 600);
      }
    });
    obs.observe(entryEl, { attributes: true, attributeFilter: ['data-kiyoko-hidden', 'class'] });

    // Start polling immediately.
    poll();
  }

  function watchForMessages() {
    var attempts = 0;
    function tryWatch() {
      var content = getMessageContent();
      if (!content) {
        if (attempts++ < 30) setTimeout(tryWatch, 300);
        return;
      }
      var initialCount = content.querySelectorAll('.entry').length;

      injectBotMessageStyles(content);

      // Inject the blanket hide rule for .entry.bot now that the shadow root
      // is confirmed ready. This runs before any message arrives, so the CSS
      // is already parsed by the time GECX inserts the first .entry.bot —
      // no observer callback gap, no paint flash.
      var msgListShadow = content.getRootNode();
      if (msgListShadow && !msgListShadow.getElementById('kiyoko-entry-hide')) {
        var hideStyle = document.createElement('style');
        hideStyle.id = 'kiyoko-entry-hide';
        hideStyle.textContent = '.entry.bot { transition: opacity 0.15s ease !important; } .entry.bot.kiyoko-ready { opacity: 1 !important; }';
        msgListShadow.appendChild(hideStyle);
      }

      var scrollEl = msgListShadow && msgListShadow.getElementById('message-list');

      // Intercept scrollTop on #message-list to block GECX auto-scrolling.
      // We lock it to 0 until the first bot response is revealed, then restore.
      var scrollLocked = false;
      if (scrollEl) {
        scrollLocked = true;
        // Get the original scrollTop descriptor from the prototype chain
        var proto = Object.getPrototypeOf(scrollEl);
        while (proto && !Object.getOwnPropertyDescriptor(proto, 'scrollTop')) {
          proto = Object.getPrototypeOf(proto);
        }
        var originalDescriptor = proto && Object.getOwnPropertyDescriptor(proto, 'scrollTop');
        try {
          Object.defineProperty(scrollEl, 'scrollTop', {
            get: function() {
              return originalDescriptor ? originalDescriptor.get.call(scrollEl) : 0;
            },
            set: function(val) {
              if (!scrollLocked && originalDescriptor) {
                originalDescriptor.set.call(scrollEl, val);
              }
              // While locked, silently ignore
            },
            configurable: true
          });
        } catch(e) {
          // defineProperty failed — fall back to CSS overflow lock
          scrollEl.style.setProperty('overflow', 'hidden', 'important');
        }
      }

      // Remove GECX's scroll spacer — a plain DIV with inline height injected
      // directly into .content to force auto-scroll. No class, just inline style.
      function removeScrollSpacer() {
        if (!content) return;
        Array.from(content.children).forEach(function(el) {
          if (el.tagName === 'DIV' && !el.className && el.getAttribute('style') &&
              el.getAttribute('style').indexOf('height') !== -1) {
            el.style.setProperty('height', '0', 'important');
            el.style.setProperty('min-height', '0', 'important');
            el.style.setProperty('max-height', '0', 'important');
            el.style.setProperty('overflow', 'hidden', 'important');
            if (!el._kiyokoSpacerWatched) {
              el._kiyokoSpacerWatched = true;
              new MutationObserver(function() {
                el.style.setProperty('height', '0', 'important');
                el.style.setProperty('min-height', '0', 'important');
              }).observe(el, { attributes: true, attributeFilter: ['style'] });
            }
          }
        });
      }

      // Unlock scroll when first bot entry gets kiyoko-ready.
      if (scrollEl) {
        new MutationObserver(function(mutations) {
          if (!scrollLocked) return;
          for (var i = 0; i < mutations.length; i++) {
            var t = mutations[i].target;
            if (t.classList && t.classList.contains('kiyoko-ready') &&
                t.classList.contains('entry') && t.classList.contains('bot')) {
              scrollLocked = false;
              try { delete scrollEl.scrollTop; } catch(e) {}
              scrollEl.style.removeProperty('overflow');
              break;
            }
          }
        }).observe(content, { attributes: true, subtree: true, attributeFilter: ['class'] });
      }

      var firstUserMessage = true;

      // Zero any existing spacer immediately on attach, then watch for changes.
      // Watch content for the spacer div being added and zero it immediately.
      removeScrollSpacer();
      new MutationObserver(function() {
        removeScrollSpacer();
      }).observe(content, { childList: true, subtree: true });

      // Prefetch product cards as soon as GECX starts streaming tile links.
      // Walks shadow roots to find a.tile hrefs and fires fetches immediately.
      new MutationObserver(function() {
        var tiles = [];
        (function walk(root) {
          root.querySelectorAll('a.tile').forEach(function(t) { tiles.push(t); });
          root.querySelectorAll('*').forEach(function(el) {
            if (el.shadowRoot) walk(el.shadowRoot);
          });
        })(document.querySelector('chat-messenger') || document.body);
        var handles = tiles.map(function(t) {
          var m = t.href && t.href.match(/\/products\/([^?#]+)/);
          return m ? m[1] : null;
        }).filter(Boolean);
        if (handles.length) prefetchHandles(handles);
      }).observe(content, { childList: true, subtree: true });

      // Hide every .entry.bot the instant it appears and monitor it.
      // Also fade out the landing UI when the first user message appears.
      new MutationObserver(function(mutations) {
        injectBotMessageStyles(content);
        mutations.forEach(function(mutation) {
          // New entry added
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType !== 1) return;
            if (!node.classList.contains('entry')) return;
            if (!node.classList.contains('bot')) {
              checkAndFadeEntry();
              firstUserMessage = false;
              removeScrollSpacer();
              return;
            }
            monitorEntryForReveal(node);
          });
          // class attribute changed on an existing .entry.bot
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var node = mutation.target;
            if (!node.classList.contains('entry') || !node.classList.contains('bot')) return;
            // If GECX stripped kiyoko-ready after we revealed, put it back immediately
            if (node._kiyokoRevealed && !node.classList.contains('kiyoko-ready')) {
              node.classList.add('kiyoko-ready');
              return;
            }
            // GECX removed 'loading' — entry is fully rendered
            // Only re-trigger if not already being monitored
            if (!node.classList.contains('loading') && node.dataset.kiyokoHidden &&
                !node.classList.contains('kiyoko-ready') && !node._kiyokoMonitored) {
              monitorEntryForReveal(node);
            }
          }
        });
      }).observe(content, { childList: true, attributes: true, attributeFilter: ['class'], subtree: true });

      // Poller for landing fade (fallback if MutationObserver misses first entry)
      if (messagePoller) clearInterval(messagePoller);
      messagePoller = setInterval(function() {
        var c = getMessageContent();
        if (!c) return;
        var currentCount = c.querySelectorAll('.entry').length;
        if (currentCount > initialCount) {
          checkAndFadeEntry();
          clearInterval(messagePoller);
          messagePoller = null;
        }
      }, 500);


    }
    tryWatch();
  }

  function getMessageContent() {
    var container = document.querySelector('chat-messenger-container');
    var shadow = container && container.shadowRoot;
    var wrapper = shadow && shadow.querySelector('.message-list-wrapper');
    var msgList = wrapper && wrapper.querySelector('chat-messenger-message-list');
    return msgList && msgList.shadowRoot && msgList.shadowRoot.querySelector('.content');
  }

  function checkAndFadeEntry() {
    var entry = document.querySelector('.kiyoko-entry-point');
    if (entry && entry.style.display !== 'none' && entry.style.opacity !== '0') {
      entry.style.transition = 'opacity 0.4s ease';
      entry.style.opacity = '0';
      setTimeout(function() { entry.style.display = 'none'; }, 400);
    }
  }

  function moveChatMessenger() {
    var messenger = document.querySelector('chat-messenger');
    var body = document.getElementById('kiyoko-chat-body');
    if (messenger && body && !body.contains(messenger)) {
      body.appendChild(messenger);
    }
  }

  function hideChatMessengerTitlebar() {
    var messenger = document.querySelector('chat-messenger');
    if (!messenger) return;

    function injectStyle(root, id, css) {
      if (!root) return;
      if (root.getElementById && root.getElementById(id)) return;
      var style = document.createElement('style');
      style.id = id;
      style.textContent = css;
      root.appendChild(style);
    }

    // Poll every 100ms until cb() returns true, up to maxAttempts (default 60 = 6s).
    function retryUntil(cb, maxAttempts) {
      var attempts = 0;
      function attempt() {
        if (cb()) return;
        if (++attempts < (maxAttempts || 60)) setTimeout(attempt, 100);
      }
      attempt();
    }

    // Inject container styles — retried until shadow root is available.
    retryUntil(function() {
      var container = messenger.querySelector('chat-messenger-container');
      if (!container || !container.shadowRoot) return false;
      injectStyle(container.shadowRoot, 'kiyoko-container-style', `
        .chat-wrapper {
          --chat-messenger-internal-chat-wrapper-visibility: visible !important;
          visibility: visible !important;
          --chat-messenger-internal-chat-wrapper-transform: unset !important;
          transform: unset !important;
          transition: none !important;
          animation: none !important;
          display: flex !important;
          flex-direction: column !important;
          height: 100% !important;
          position: relative !important;
        }
        @media (max-width: 749px) {
          .chat-wrapper {
            left: unset !important;
            top: unset !important;
          }
        }
        slot[name="titlebar"],
        chat-messenger-titlebar {
          display: none !important;
        }
        .chat-actions {
          background: transparent !important;
          position: absolute !important;
          bottom: 0 !important;
          left: 0 !important;
          right: 0 !important;
          transition: none !important;
          animation: none !important;
          transform: none !important;
        }
        .message-list-wrapper {
          flex: 1 !important;
          min-height: 0 !important;
          transition: none !important;
          animation: none !important;
          transform: none !important;
        }
      `);
      return true;
    });

    // Style message list background
    retryUntil(function() {
      var msgContainer = messenger.querySelector('chat-messenger-container');
      var containerShadow = msgContainer && msgContainer.shadowRoot;
      var outerWrapper = containerShadow && containerShadow.querySelector('.message-list-wrapper');
      var msgList = outerWrapper && outerWrapper.querySelector('chat-messenger-message-list');
      if (!msgList || !msgList.shadowRoot) return false;
        var msglistCss = `
          .message-list-wrapper {
            background:
              radial-gradient(circle, #ffffff 1.5px, transparent 1.5px),
              linear-gradient(to top, #ECE7FF 0%, #ffffff 30%) !important;
            background-size: 20px 20px, 100% 100% !important;
            background-position: 0 0, 0 0 !important;
          }
          #message-list {
            -webkit-mask-image: linear-gradient(to bottom, transparent 0%, white 6%, white 94%, transparent 100%) !important;
            mask-image: linear-gradient(to bottom, transparent 0%, white 6%, white 94%, transparent 100%) !important;
            --chat-messenger-internal-chat-overflow: hidden auto !important;
            scroll-behavior: auto !important;
          }
          #message-list .content {
            padding-bottom: 120px !important;
          }
          .scroll-to-bottom-button {
            bottom: 5rem !important;
          }

          @media (max-width: 749px) {
            #message-list .content {
              padding-bottom: 140px !important;
            }
            .scroll-to-bottom-button {
              bottom: 8rem !important;
            }
          }
        `;
        var existingMsglistStyle = msgList.shadowRoot.getElementById('kiyoko-msglist-style');
        if (existingMsglistStyle) {
          var stale = existingMsglistStyle.textContent.indexOf('df-product-detail-carousel') !== -1
                   || existingMsglistStyle.textContent.indexOf('scroll-to-bottom-button') === -1
                   || existingMsglistStyle.textContent.indexOf('8rem') === -1
                   || existingMsglistStyle.textContent.indexOf('140px') === -1
                   || existingMsglistStyle.textContent.indexOf('white 6%') === -1
                   || existingMsglistStyle.textContent.indexOf('chat-messenger-internal-chat-overflow') === -1
                   || existingMsglistStyle.textContent.indexOf('120px') === -1
                   || existingMsglistStyle.textContent.indexOf('kiyoko-hidden-product') !== -1
                   || existingMsglistStyle.textContent.indexOf('kiyoko-spin') === -1;
          if (stale) existingMsglistStyle.textContent = msglistCss;
        } else {
          injectStyle(msgList.shadowRoot, 'kiyoko-msglist-style', msglistCss);
        }
        // Ensure the entry hide rule is also present (may have been injected
        // earlier by watchForMessages, but inject here as a fallback).
        if (!msgList.shadowRoot.getElementById('kiyoko-entry-hide')) {
          var hideStyle = document.createElement('style');
          hideStyle.id = 'kiyoko-entry-hide';
          hideStyle.textContent = '.entry.bot { transition: opacity 0.15s ease !important; } .entry.bot.kiyoko-ready { opacity: 1 !important; }';
          msgList.shadowRoot.appendChild(hideStyle);
        }
      return true;
    });

    // Style the user input field
    retryUntil(function() {
      var msgContainer = messenger.querySelector('chat-messenger-container');
      var containerShadow = msgContainer && msgContainer.shadowRoot;
      var wrapper = containerShadow && containerShadow.querySelector('.message-list-wrapper');
      var msgList = wrapper && wrapper.querySelector('chat-messenger-message-list');
      var userInput = msgList && msgList.shadowRoot && msgList.shadowRoot.querySelector('chat-messenger-user-input');
      if (!userInput) {
        // Try alternate path via chat-actions
        var chatActions = containerShadow && containerShadow.querySelector('.chat-actions');
        userInput = chatActions && chatActions.querySelector('chat-messenger-user-input');
      }
      if (!userInput || !userInput.shadowRoot) return false;
        injectStyle(userInput.shadowRoot, 'kiyoko-input-style', `
          .input-container {
            background: transparent !important;
            position: absolute !important;
            bottom: 2.5rem !important;
            left: 16px !important;
            right: 16px !important;
            width: auto !important;
            padding: 0 !important;
          }
          @media (max-width: 749px) {
            .input-container {
              bottom: 4rem !important;
            }
          }
          .input-box-wrapper {
            background: #ffffff !important;
            border: 1px solid #e8e8ec !important;
            border-radius: 20px !important;
            padding: 6px 6px 6px 16px !important;
            display: flex !important;
            align-items: center !important;
            box-shadow: 0 1px 4px rgba(0,0,0,0.06) !important;
          }
          .input-wrapper {
            flex: 1 !important;
            min-width: 0 !important;
          }
          .input-box {
            background: transparent !important;
            border: none !important;
            outline: none !important;
            font-size: 14px !important;
            color: #131112 !important;

            width: 100% !important;
            resize: none !important;
            padding: 0 !important;
            line-height: 1.5 !important;
            height: auto !important;
            min-height: 20px !important;
          }
          .input-box::placeholder {
            color: #9a9a9a !important;
          }
          .input-element-wrapper {
            border: none !important;
            box-shadow: none !important;
          }
          .send-icon-button-wrapper {
            flex-shrink: 0 !important;
            display: none !important;
          }
          .send-icon-button-wrapper.visible {
            display: flex !important;
          }
          .input-box-wrapper {
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
          }
          .input-wrapper { order: 1 !important; align-self: center !important; }
          .kiyoko-clear-input { order: 2 !important; align-self: center !important; }
          .send-icon-button-wrapper { order: 3 !important; align-self: flex-start !important; display: flex !important; align-items: center !important; justify-content: center !important; }
          .input-element-wrapper { display: flex !important; align-items: center !important; }
          .input-content-wrapper { display: flex !important; align-items: center !important; }
          .kiyoko-clear-input {
            height: 36px !important;
            width: 50px !important;
            display: none !important;
            background: none !important;
            border: none !important;
            cursor: pointer !important;
            color: #1C1B1F !important;
            align-items: center !important;
            justify-content: center !important;
            flex-shrink: 0 !important;
            order: 2 !important;
          }
          .kiyoko-clear-input.visible {
            display: flex !important;
          }
          #send-icon-button {
            --md-filled-icon-button-container-color: #cac4f4;
            --md-filled-icon-button-container-shape: 9999px;
            --md-filled-icon-button-container-width: 36px;
            --md-filled-icon-button-container-height: 36px;
            --md-filled-icon-button-icon-color: #5534EB;
          }
        `);

        // Style send button shadow root
        var sendBtn = userInput.shadowRoot.querySelector('#send-icon-button');
        if (sendBtn && sendBtn.shadowRoot) {
          injectStyle(sendBtn.shadowRoot, 'kiyoko-send-style', `
            #button {
              border-radius: 50% !important;
              width: 36px !important;
              height: 36px !important;
              min-width: 36px !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              background: #CAC4F4 !important;
              color: #5534EB !important;
              opacity: 1 !important;
            }
            /* Remove GECX's disabled overlay */
            #button::before { display: none !important; }
            .icon { display: flex !important; align-items: center !important; justify-content: center !important; }
          `);
        }

        // Add custom clear button — insert before send button in input-box-wrapper
        var inputBoxWrapper = userInput.shadowRoot.querySelector('.input-box-wrapper');
        var sendBtnWrapper = userInput.shadowRoot.querySelector('.send-icon-button-wrapper');
        if (inputBoxWrapper && sendBtnWrapper && !userInput.shadowRoot.querySelector('.kiyoko-clear-input')) {
          var clearBtn = document.createElement('button');
          clearBtn.className = 'kiyoko-clear-input';
          clearBtn.setAttribute('aria-label', 'Clear input');
          clearBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
          clearBtn.style.cssText = '';
          var textarea = userInput.shadowRoot.querySelector('textarea');
          var sendWrapper = userInput.shadowRoot.querySelector('.send-icon-button-wrapper');
          // Hide send wrapper initially — also inject CSS as belt-and-suspenders
          if (sendWrapper) {
            sendWrapper.classList.remove('visible');
            sendWrapper.style.setProperty('display', 'none', 'important');
          }

          // Replace send icon with arrow image rotated upward
          var sendIcon = userInput.shadowRoot.querySelector('.send-icon');
          if (sendIcon) {
            var headerBtn = document.querySelector('.header-gecx-btn');
            var arrowUrl = headerBtn ? headerBtn.dataset.arrow : '';
            sendIcon.style.display = 'none';
            var arrowImg = document.createElement('img');
            arrowImg.src = arrowUrl;
            arrowImg.width = 16;
            arrowImg.height = 16;
            arrowImg.style.transform = 'rotate(-90deg)';
            arrowImg.style.display = 'block';
            sendIcon.parentElement.appendChild(arrowImg);
          }

          function updateInputState() {
            var hasText = !!(textarea && textarea.value);
            clearBtn.classList.toggle('visible', hasText);
            if (sendWrapper) {
              sendWrapper.classList.toggle('visible', hasText);
              sendWrapper.style.setProperty('display', hasText ? '' : 'none', 'important');
            }
          }

          textarea && textarea.addEventListener('input', updateInputState);

          // Watch for GECX clearing textarea after send
          if (textarea) {
            new MutationObserver(function() {
              updateInputState();
            }).observe(textarea, { attributes: true });
            // Also poll briefly after send button click
            if (sendWrapper) {
              sendWrapper.addEventListener('click', function() {
                setTimeout(updateInputState, 300);
                setTimeout(updateInputState, 600);
              });
            }
          }
          clearBtn.addEventListener('click', function() {
            if (textarea) {
              textarea.value = '';
              textarea.dispatchEvent(new Event('input', { bubbles: true }));
              clearBtn.classList.remove('visible');
              if (sendWrapper) sendWrapper.classList.remove('visible');
            }
          });
          // Insert before send button wrapper
          sendBtnWrapper.parentNode.insertBefore(clearBtn, sendBtnWrapper);

          // Fix placeholder — retry since GECX may reset it
          function setPlaceholder() {
            if (textarea && textarea.getAttribute('placeholder') !== 'Ask anything...') {
              textarea.setAttribute('placeholder', 'Ask anything...');
            }
          }
          setPlaceholder();
          setTimeout(setPlaceholder, 300);
          setTimeout(setPlaceholder, 800);
          if (textarea) {
            new MutationObserver(setPlaceholder).observe(textarea, { attributes: true, attributeFilter: ['placeholder'] });
          }

          // Inject font into input shadow root
          // Inject font + sizing into input shadow root
          var fontStyle = document.createElement('style');
          fontStyle.id = 'kiyoko-font-style';
          fontStyle.textContent = '* { font-family: ' + getBodyFont() + ' !important; font-weight: 500 !important; font-size: 14px !important; }';
          userInput.shadowRoot.appendChild(fontStyle);
        }
      return true;
    });
  }

  var gecxInitialized = false;

  function openGecxChat() {
    var messenger = document.querySelector('chat-messenger');
    if (messenger) {
      messenger.classList.remove('messenger-hidden');
      messenger.classList.remove('slide-in');
      messenger.classList.remove('slide-over');
      messenger.classList.remove('no-transition');
    }
    if (!gecxInitialized) {
      gecxInitialized = true;
      var widget = document.querySelector('gecx-shopify-chat-widget');
      if (widget && widget.startNewSession) {
        widget.startNewSession();
      }
    }
  }

  function openModal() {
    if (!modal) buildModal();
    moveChatMessenger();
    if (!isOpen) {
      openGecxChat();
      setTimeout(function() {
        hideChatMessengerTitlebar();
        isOpen = true;
        modal.classList.remove('is-closing');
        modal.classList.add('is-open');
        backdrop.classList.add('is-open');
        document.body.classList.add('kiyoko-chat-open');
        watchForMessages();
        watchForCarousels();
      }, 100);
    }
  }

  function closeModal() {
    if (!modal) return;
    isOpen = false;
    document.body.classList.remove('kiyoko-chat-open');
    backdrop.classList.remove('is-open');
    modal.classList.remove('is-open');
    modal.classList.add('is-closing');
    // Clean up closing class after the transition finishes
    var duration = parseFloat(getComputedStyle(modal).transitionDuration) * 1000 || 200;
    setTimeout(function() {
      modal.classList.remove('is-closing');
    }, duration + 50);
  }

  function initDragToDismiss() {
    if (!modal) return;
    // Allow dragging from the handle OR the titlebar
    var dragZone = modal.querySelector('.kiyoko-chat-titlebar') || modal.querySelector('.kiyoko-chat-drag-handle');
    if (!dragZone) return;

    var startY = 0;
    var currentY = 0;
    var isDragging = false;

    dragZone.addEventListener('touchstart', function (e) {
      startY = e.touches[0].clientY;
      currentY = startY;
      isDragging = true;
      modal.style.transition = 'none';
    }, { passive: true });

    dragZone.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      currentY = e.touches[0].clientY;
      var diff = currentY - startY;
      if (diff > 0) {
        modal.style.transform = 'translateY(' + diff + 'px)';
      }
    }, { passive: true });

    dragZone.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;
      modal.style.transition = '';
      var diff = currentY - startY;
      if (diff > 80) {
        modal.style.transform = '';
        closeModal();
      } else {
        modal.style.transform = '';
      }
    });
  }

  // ── Product card fetch cache ───────────────────────────────────────────────
  var _cardCache = {}; // in-memory cache, also backed by sessionStorage

  function fetchCardCached(handle) {
    if (_cardCache[handle]) return _cardCache[handle];
    // Check sessionStorage
    try {
      var cached = sessionStorage.getItem('kiyoko_card_' + handle);
      var cachedBadge = sessionStorage.getItem('kiyoko_badge_' + handle);
      if (cached) {
        var p = Promise.resolve({ html: cached, badgeHtml: cachedBadge || null, handle: handle });
        _cardCache[handle] = p;
        return p;
      }
    } catch(e) {}
    // Fetch and cache
    var p = Promise.all([
      fetch('/products/' + handle + '?section_id=boost-search-product-card')
        .then(function(r) { return r.ok ? r.text() : null; }),
      fetch('/products/' + handle + '?section_id=boost-product-badge')
        .then(function(r) { return r.ok ? r.text() : null; })
    ]).then(function(results) {
      try {
        if (results[0]) sessionStorage.setItem('kiyoko_card_' + handle, results[0]);
        if (results[1]) sessionStorage.setItem('kiyoko_badge_' + handle, results[1]);
      } catch(e) {}
      return { html: results[0], badgeHtml: results[1], handle: handle };
    });
    _cardCache[handle] = p;
    return p;
  }

  // Prefetch a list of handles without blocking
  function prefetchHandles(handles) {
    handles.forEach(function(handle) {
      if (!_cardCache[handle]) fetchCardCached(handle);
    });
  }

  // ── Product carousel replacement ──────────────────────────────────────────

  function hideEntry(entryEl) {
    entryEl.dataset.kiyokoHidden = 'true';
  }

  // Immediately hide the GECX card wrapper inside df-card's shadow root.
  // Works for both carousel (.product_detail_carousel) and single (.base_product_detail).
  function hideDfCardWrapper(dfCard) {
    if (!dfCard || !dfCard.shadowRoot) return;
    if (dfCard.shadowRoot.getElementById('kiyoko-dfcard-hide')) return;
    var s = document.createElement('style');
    s.id = 'kiyoko-dfcard-hide';
    s.textContent = '.card-wrapper { display: none !important; }';
    dfCard.shadowRoot.appendChild(s);
  }

  // Called after our grid is injected — removes the hide so our card is visible.
  function showDfCard(dfCard) {
    if (!dfCard || !dfCard.shadowRoot) return;
    var s = dfCard.shadowRoot.getElementById('kiyoko-dfcard-hide');
    if (s) s.remove();
  }

  // Walk up from a node to find the .entry.bot ancestor, crossing shadow
  // boundaries. At each shadow boundary we also walk the light DOM ancestors
  // of the shadow host, because .entry.bot is a light DOM parent of
  // chat-messenger-utterance inside the message-list shadow root.
  function findEntryBot(node) {
    var current = node;
    while (current) {
      // Check light DOM ancestors at this level first.
      var el = current;
      while (el) {
        if (el.classList && el.classList.contains('entry') && el.classList.contains('bot')) {
          return el;
        }
        el = el.parentElement;
      }
      // Cross the shadow boundary upward.
      var root = current.getRootNode();
      if (!root || root === document) break;
      current = root.host || null;
    }
    return null;
  }

  // Reveal an entry by adding .kiyoko-ready, which the injected CSS transitions
  // from opacity 0 to 1. The CSS rule handles the animation.
  function revealEntry(entryEl) {
    entryEl.classList.add('kiyoko-ready');
    entryEl._kiyokoRevealed = true;
    delete entryEl.dataset.kiyokoHidden;
  }

  // Walk shadow roots looking for a specific tag — used to detect text/chip content.
  function findInShadowsByTag(root, tag) {
    if (root.querySelector(tag)) return true;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot && findInShadowsByTag(all[i].shadowRoot, tag)) return true;
    }
    return false;
  }

  // Recursively collect unprocessed df-product-detail-carousel elements,
  // crossing shadow root boundaries.
  function collectCarousels(root, results) {
    root.querySelectorAll('df-product-detail-carousel').forEach(function(c) {
      if (!c.dataset.kiyokoReplaced) results.push(c);
    });
    root.querySelectorAll('*').forEach(function(el) {
      if (el.shadowRoot) collectCarousels(el.shadowRoot, results);
    });
  }

  // Recursively collect unprocessed df-product-detail (single card) elements.
  function collectSingleProducts(root, results) {
    root.querySelectorAll('df-product-detail').forEach(function(c) {
      if (!c.dataset.kiyokoReplaced) results.push(c);
    });
    root.querySelectorAll('*').forEach(function(el) {
      if (el.shadowRoot) collectSingleProducts(el.shadowRoot, results);
    });
  }

  var carouselObserver = null;
  var carouselScanTimer = null;

  function scheduleScan() {
    // Run immediately to catch products as fast as possible, then debounce
    // subsequent calls so we don't scan on every mutation.
    clearTimeout(carouselScanTimer);
    scanForCarousels();
    carouselScanTimer = setTimeout(scanForCarousels, 100);
  }

  function scanForCarousels() {
    var carousels = [];
    collectCarousels(document, carousels);
    carousels.forEach(handleCarousel);
    var singles = [];
    collectSingleProducts(document, singles);
    singles.forEach(handleSingleProduct);
  }

  function watchForCarousels() {
    if (carouselObserver) return;
    // document.body subtree observer cannot cross shadow roots, but any DOM
    // mutation (GECX updating light-DOM wrappers, attributes, etc.) is enough
    // signal to trigger our shadow-walking scan.
    carouselObserver = new MutationObserver(scheduleScan);
    carouselObserver.observe(document.body, { childList: true, subtree: true });
    // Also scan immediately in case carousels are already present.
    scanForCarousels();
  }

  function handleSingleProduct(dfProductDetail) {
    if (dfProductDetail.dataset.kiyokoReplaced) return;
    dfProductDetail.dataset.kiyokoReplaced = 'true';


    var entryEl = findEntryBot(dfProductDetail);
    if (entryEl) hideEntry(entryEl);

    // Find df-card and hide its shadow content immediately.
    var dfCardEarly = dfProductDetail;
    while (dfCardEarly && dfCardEarly.tagName !== 'DF-CARD') {
      var re = dfCardEarly.getRootNode();
      if (!re || re === document) break;
      dfCardEarly = re.host || null;
    }
    hideDfCardWrapper(dfCardEarly);

    requestAnimationFrame(function() {
      _processSingleProduct(dfProductDetail, entryEl);
    });
  }

  function _processSingleProduct(dfProductDetail, entryEl) {

    // Find the df-card that wraps this element — we'll replace its shadow content.
    var dfCard = dfProductDetail;
    while (dfCard && dfCard.tagName !== 'DF-CARD') {
      var r = dfCard.getRootNode();
      if (!r || r === document) break;
      dfCard = r.host || null;
    }

    // Extract the product handle from the product-link href.
    var shadow = dfProductDetail.shadowRoot;
    var link = shadow && shadow.querySelector('a.product-link');
    if (!link) {
      // Try deeper
      var container = shadow && shadow.querySelector('df-product-container');
      var containerShadow = container && container.shadowRoot;
      link = containerShadow && containerShadow.querySelector('a.product-link');
    }
    var href = link && link.getAttribute('href');
    var match = href && href.match(/\/products\/([^?#]+)/);
    var handle = match && match[1];


    if (!handle) {

      if (entryEl) revealEntry(entryEl);
      return;
    }

    // Fetch native card (cached)
    fetchCardCached(handle).then(function(result) {
      var html = result.html;
      var badgeHtml = result.badgeHtml;
      if (!html) { if (entryEl) revealEntry(entryEl); return; }

      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var card = doc.querySelector('.boost-search-card-wrapper, [id*="boost-search-product-card"]');
      if (!card) { if (entryEl) revealEntry(entryEl); return; }

      // Remove unwanted elements
      card.querySelectorAll('.quick_add_view_new, wishlist-button-collection').forEach(function(el) { el.remove(); });
      card.querySelectorAll('.media--hover-effect').forEach(function(el) {
        el.classList.remove('media--hover-effect');
        var imgs = el.querySelectorAll('img');
        if (imgs.length > 1) { for (var i = 1; i < imgs.length; i++) imgs[i].remove(); }
      });

      // Inject badge
      if (badgeHtml) {
        var badgeDoc = parser.parseFromString(badgeHtml, 'text/html');
        var badgeEl = badgeDoc.querySelector('.bk-badge-data');
        if (badgeEl) {
          try {
            var badges = JSON.parse(badgeEl.getAttribute('data-badges') || 'null');
            var badgeText = Array.isArray(badges) && badges.length ? badges[0] : null;
            var badgeContainer = card.querySelector('.product-badges, .Product_card_gallery_mainbadges_new');
            if (badgeContainer) {
              badgeContainer.innerHTML = '';
              if (badgeText) {
                var badge = document.createElement('div');
                badge.className = 'product-badges__badge product-badges__badge--rectangle color-scheme-2 Product_card_gallery_innerbadges_new';
                badge.textContent = badgeText;
                badgeContainer.appendChild(badge);
              }
            }
          } catch(e) {}
        }
      }

      // Build a wrapper to hold the card
      var wrapper = document.createElement('div');
      wrapper.className = 'kiyoko-product-grid kiyoko-single-product';
      var item = document.createElement('div');
      item.className = 'kiyoko-product-grid__item';
      item.innerHTML = card.innerHTML;
      wrapper.appendChild(item);

      // Fix images
      wrapper.querySelectorAll('img').forEach(function(img) {
        img.loading = 'eager';
        img.sizes = '300px';
        if (img.dataset.src) img.src = img.dataset.src;
      });

      // Find the best place to inject — the df-card shadow root or the entry itself
      var targetRoot = dfCard && dfCard.shadowRoot;
      if (targetRoot) {
        // Inject theme CSS
        var customCssLink = document.querySelector('link[href*="custom.css"]');
        if (customCssLink) {
          var linkEl = document.createElement('link');
          linkEl.rel = 'stylesheet';
          linkEl.href = customCssLink.href;
          targetRoot.appendChild(linkEl);
        }
        document.querySelectorAll('link[rel="stylesheet"]').forEach(function(l) {
          targetRoot.appendChild(l.cloneNode());
        });
        var overflowStyle = document.createElement('style');
        overflowStyle.textContent = '.card-wrapper { display: none !important; } .kiyoko-product-grid__item, .kiyoko-product-grid__item *, .card-gallery, .Product_card_gallery_new, product-card { overflow: visible !important; } .Product_card_gallery_mainbadges_new { top: 0 !important; left: 50% !important; transform: translate(-50%,-50%) !important; display: flex !important; justify-content: center !important; z-index: 10 !important; } .media--hover-effect img:nth-child(2) { display: none !important; } .kiyoko-single-product { padding: 12px; }';
        targetRoot.appendChild(overflowStyle);
        targetRoot.appendChild(wrapper);
        // Remove the hide style now that our content is injected
        showDfCard(dfCard);
      } else {
        // Fallback: replace inline in the entry
        if (entryEl) entryEl.appendChild(wrapper);
      }

      // Re-find entryEl fresh in case GECX replaced the loading node
      var freshEntry = findEntryBot(dfProductDetail) || (dfCard && findEntryBot(dfCard)) || entryEl;
      if (freshEntry) {
        if (!freshEntry.dataset.kiyokoHidden) freshEntry.dataset.kiyokoHidden = 'true';
        revealEntry(freshEntry);
      }
    });
  }

  function handleCarousel(carousel) {
    if (carousel.dataset.kiyokoReplaced) return;

    var entryEl = findEntryBot(carousel);
    if (entryEl) hideEntry(entryEl);

    requestAnimationFrame(function() {
      processCarousel(carousel, entryEl);
    });
  }

  function processCarousel(carousel, entryEl) {
    if (carousel.dataset.kiyokoReplaced) return;
    carousel.dataset.kiyokoReplaced = 'true';

    var shadow = carousel.shadowRoot;
    if (!shadow) {
      if (entryEl) revealEntry(entryEl);
      return;
    }



    var tiles = shadow.querySelectorAll('a.tile');
    var handles = Array.from(tiles).map(function(t) {
      var match = t.href.match(/\/products\/([^?#]+)/);
      return match ? match[1] : null;
    }).filter(Boolean);

    if (!handles.length) {
      if (entryEl) revealEntry(entryEl);
      return;
    }

    // Build our custom grid carousel
    var grid = document.createElement('div');
    grid.className = 'kiyoko-product-grid';
    var items = [];

    // Fetch all product cards and badges in parallel
    Promise.all(handles.map(fetchCardCached)).then(function(results) {
      results.forEach(function(result) {
        if (!result.html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(result.html, 'text/html');
        var card = doc.querySelector('.boost-search-card-wrapper, [id*="boost-search-product-card"]');
        if (!card) return;

        // Remove unwanted elements
        card.querySelectorAll('.quick_add_view_new, wishlist-button-collection').forEach(function(el) {
          el.remove();
        });

        // Remove hover effect and second image
        card.querySelectorAll('.media--hover-effect').forEach(function(el) {
          el.classList.remove('media--hover-effect');
          var imgs = el.querySelectorAll('img');
          if (imgs.length > 1) {
            for (var i = 1; i < imgs.length; i++) imgs[i].remove();
          }
        });

        // Inject badge from metafield
        if (result.badgeHtml) {
          var badgeDoc = parser.parseFromString(result.badgeHtml, 'text/html');
          var badgeEl = badgeDoc.querySelector('.bk-badge-data');
          if (badgeEl) {
            try {
              var badges = JSON.parse(badgeEl.getAttribute('data-badges') || 'null');
              var badgeText = Array.isArray(badges) && badges.length ? badges[0] : null;
              var badgeContainer = card.querySelector('.product-badges, .Product_card_gallery_mainbadges_new');
              if (badgeContainer) {
                badgeContainer.innerHTML = '';
                if (badgeText) {
                  var badge = document.createElement('div');
                  badge.className = 'product-badges__badge product-badges__badge--rectangle color-scheme-2 Product_card_gallery_innerbadges_new';
                  badge.textContent = badgeText;
                  badgeContainer.appendChild(badge);
                }
              }
            } catch(e) {}
          }
        }

        var wrapper = document.createElement('div');
        wrapper.className = 'kiyoko-product-grid__item';
        wrapper.innerHTML = card.innerHTML;
        items.push(wrapper);
      });

      // Chunk items into slides — 2 per slide on mobile, 4 on desktop
      var slideSize = window.innerWidth <= 749 ? 2 : 4;
      var slideCount = Math.ceil(items.length / slideSize);

      var trackWrapper = document.createElement('div');
      trackWrapper.className = 'kiyoko-product-grid__track-wrapper';
      var track = document.createElement('div');
      track.className = 'kiyoko-product-grid__track';

      for (var s = 0; s < slideCount; s++) {
        var slide = document.createElement('div');
        slide.className = 'kiyoko-product-grid__slide';
        items.slice(s * slideSize, (s + 1) * slideSize).forEach(function(item) {
          slide.appendChild(item);
        });
        track.appendChild(slide);
      }
      trackWrapper.appendChild(track);
      grid.appendChild(trackWrapper);

      // Shared slide state used by both dots and swipe
      var currentSlide = 0;
      var dotsEl = null;

      function goToSlide(idx) {
        currentSlide = Math.max(0, Math.min(idx, slideCount - 1));
        track.style.transform = 'translateX(' + (-100 * currentSlide) + '%)';
        if (dotsEl) {
          dotsEl.querySelectorAll('.kiyoko-product-grid__dot').forEach(function(d, i) {
            d.classList.toggle('is-active', i === currentSlide);
          });
        }
      }

      // Dots — only when more than one slide
      if (slideCount > 1) {
        dotsEl = document.createElement('div');
        dotsEl.className = 'kiyoko-product-grid__dots';
        for (var d = 0; d < slideCount; d++) {
          (function(idx) {
            var dot = document.createElement('button');
            dot.className = 'kiyoko-product-grid__dot' + (idx === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Slide ' + (idx + 1));
            dot.addEventListener('click', function() { goToSlide(idx); });
            dotsEl.appendChild(dot);
          })(d);
        }
        grid.appendChild(dotsEl);
      }

      // Touch swipe on mobile
      if (slideCount > 1) {
        var touchStartX = 0;
        var touchStartY = 0;
        var isSwiping = false;

        trackWrapper.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          isSwiping = false;
        }, { passive: true });

        trackWrapper.addEventListener('touchmove', function(e) {
          var dx = e.touches[0].clientX - touchStartX;
          var dy = e.touches[0].clientY - touchStartY;
          // Lock to horizontal swipe only if clearly horizontal
          if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
            isSwiping = true;
          }
        }, { passive: true });

        trackWrapper.addEventListener('touchend', function(e) {
          if (!isSwiping) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var threshold = trackWrapper.offsetWidth * 0.25;
          if (dx < -threshold) {
            goToSlide(currentSlide + 1);
          } else if (dx > threshold) {
            goToSlide(currentSlide - 1);
          }
          isSwiping = false;
        }, { passive: true });
      }

      // CSS for grid will be injected into parent root alongside the grid itself

      // Fix images eager loading before inserting into DOM
      grid.querySelectorAll('img').forEach(function(img) {
        img.loading = 'eager';
        img.sizes = '200px';
        if (img.dataset.src) img.src = img.dataset.src;
        var srcset = img.getAttribute('srcset');
        if (srcset) img.srcset = srcset;
      });

      // Place grid as sibling of carousel (outside its shadow root)
      // so :host { display:none } on carousel doesn't affect our grid.
      var carouselParent = carousel.parentNode;
      if (carouselParent) {
        carouselParent.appendChild(grid);
        // Inject CSS into the parent shadow root for our grid
        var parentRoot = carouselParent.getRootNode();
        if (parentRoot && parentRoot !== document) {
          var customCssLink2 = document.querySelector('link[href*="custom.css"]');
          if (customCssLink2) {
            var linkEl2 = document.createElement('link');
            linkEl2.rel = 'stylesheet';
            linkEl2.href = customCssLink2.href;
            parentRoot.appendChild(linkEl2);
          }
          document.querySelectorAll('link[rel="stylesheet"]').forEach(function(l) {
            parentRoot.appendChild(l.cloneNode());
          });
          if (!parentRoot.getElementById('kiyoko-grid-style')) {
            var gridStyle = document.createElement('style');
            gridStyle.id = 'kiyoko-grid-style';
            gridStyle.textContent = [
              '.kiyoko-product-grid__item,.kiyoko-product-grid__item *,',
              '.card-gallery,.Product_card_gallery_new,.card-gallery-static,product-card{overflow:visible!important}',
              '.Product_card_gallery_mainbadges_new{top:0!important;left:50%!important;',
              'transform:translate(-50%,-50%)!important;display:flex!important;',
              'justify-content:center!important;z-index:10!important}',
              '.media--hover-effect img:nth-child(2){display:none!important}',
              '.kiyoko-product-grid .quick_add_button_new .quick-add__button .add-to-cart-text{font-size:12px!important}',
              '.kiyoko-product-grid .Product_card_innerbottom_texts_new{font-family:' + getBodyFont() + '!important}',
              '.kiyoko-product-grid .Product_card_innerbottom_price_new,.kiyoko-product-grid .Product_card_innerbottom_price_new *{font-family:' + getBodyFont() + '!important}'
            ].join('');
            parentRoot.appendChild(gridStyle);
          }
        }
      } else {
        // Fallback: inject into carousel shadow root
        shadow.appendChild(grid);
      }

      // Carousel is already hidden via preemptive-hide injected at define time.
      // It stays hidden permanently — our grid is outside it so it’s unaffected.
      carousel.style.removeProperty('display');

      // Force image reload
      setTimeout(function() {
        grid.querySelectorAll('img').forEach(function(img) {
          if (!img.complete || img.naturalWidth === 0) {
            var s = img.src; img.src = ''; img.src = s;
          }
        });
        grid.querySelectorAll('.card-gallery').forEach(function(gallery) {
          gallery.removeAttribute('on:pointerenter');
          gallery.removeAttribute('on:pointerleave');
          gallery.removeAttribute('data-image-ratio');
          gallery.querySelectorAll('.media--hover-effect img:nth-child(2)').forEach(function(img) {
            img.remove();
          });
        });
      }, 50);

      // Intercept ATC form submissions — use AJAX so page doesn't redirect to /cart
      grid.querySelectorAll('form[action="/cart/add"], form[data-type="add-to-cart-form"]').forEach(function(form) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var btn = form.querySelector('[name="add"], button[type="submit"]');
          var variantId = form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
          if (!variantId) return;
          var quantity = form.querySelector('[name="quantity"]');
          var qty = quantity ? parseInt(quantity.value) || 1 : 1;
          if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          }).then(function(r) { return r.json(); })
            .then(function() {
              if (btn) { btn.disabled = false; btn.textContent = 'Added!'; }
              // Trigger cart update event so header cart count refreshes
              document.dispatchEvent(new CustomEvent('cart:updated'));
              setTimeout(function() {
                if (btn) btn.textContent = 'Add to cart';
              }, 1500);
            })
            .catch(function() {
              if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
            });
        });
      });

      // Reveal the entry now that our grid is in place
      if (entryEl) revealEntry(entryEl);

      // Yotpo reviews — clone to light DOM so Yotpo can init, then copy back
      var yotpoEls = grid.querySelectorAll('.yotpo-widget-instance');
      var tempContainer = document.createElement('div');
      tempContainer.style.cssText = 'position:absolute;left:-9999px;top:-9999px;visibility:hidden;';
      document.body.appendChild(tempContainer);
      yotpoEls.forEach(function(el) {
        var clone = el.cloneNode(true);
        clone.dataset.shadowSource = el.getAttribute('data-yotpo-product-id');
        tempContainer.appendChild(clone);
      });
      if (window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets) {
        try { window.yotpoWidgetsContainer.initWidgets(); } catch(e) {}
      }
      setTimeout(function() {
        tempContainer.querySelectorAll('.yotpo-widget-instance').forEach(function(clone) {
          var productId = clone.dataset.shadowSource;
          var target = grid.querySelector('.yotpo-widget-instance[data-yotpo-product-id="' + productId + '"]');
          if (target && clone.innerHTML) {
            target.innerHTML = clone.innerHTML;
            target.querySelectorAll('.yotpo-sr-bottom-line-text--right-panel').forEach(function(el) {
              var num = el.textContent.replace(/[^0-9]/g, '');
              if (num) el.textContent = '(' + num + ')';
            });
            target.querySelectorAll('.yotpo-sr-bottom-line-score,.yotpo-sr-vertical-border').forEach(function(el) {
              el.style.display = 'none';
            });
            target.querySelectorAll('*').forEach(function(el) {
              el.style.background = 'transparent';
              el.style.border = 'none';
              el.style.boxShadow = 'none';
              el.style.padding = '0';
            });
          }
        });
        document.body.removeChild(tempContainer);
      }, 2000);
    });
  }

  // ── Public API ──
  window.KiyokoChat = {
    open: openModal,
    close: closeModal,
    toggle: function () { isOpen ? closeModal() : openModal(); }
  };

  // Hook into our header button
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header-gecx-btn')) {
      e.preventDefault();
      openModal();
    }
  });

  // ESC to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeModal();
  });

  // Build modal after GECX loads
  function init() {
    var attempts = 0;
    function tryBuild() {
      var messenger = document.querySelector('chat-messenger');
      if (messenger) {
        buildModal();
      } else if (attempts++ < 30) {
        setTimeout(tryBuild, 300);
      }
    }
    tryBuild();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Preload popular product cards into cache on page load (low priority).
  // Uses requestIdleCallback so it doesn't compete with critical resources.
  (function preloadPopularCards() {
    var preload = function() {
      fetch('/collections/bestsellers/products.json?limit=12')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) {
          if (!data || !data.products) return;
          var handles = data.products.map(function(p) { return p.handle; });
          // Stagger fetches so we don't hammer the server
          handles.forEach(function(handle, i) {
            setTimeout(function() { fetchCardCached(handle); }, i * 150);
          });
        })
        .catch(function() {});
    };
    if (window.requestIdleCallback) {
      requestIdleCallback(preload, { timeout: 3000 });
    } else {
      setTimeout(preload, 2000);
    }
  })();
})();
